<template>
  <div class="orderBox">
    <el-row class="orderCenter">
      <el-col class="borde">
        <div>
          <el-col :span="12" class="bordeLeft">用户信息</el-col>
        </div>
      </el-col>
    </el-row>
    <!-- 订单详情 -->
    <el-row>
      <el-row class="statusRow">
        <el-col :span="19" class="status"> </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="toOrder()">查看订单</el-button>
        </el-col>
        <el-col :span="2">
          <el-button v-if="status == '0000'" @click="toBack()">返回</el-button>
        </el-col>
      </el-row>
      <el-row id="printContent" style="padding: 10px">
        <el-row class="center">
          <el-col :span="12" class="centerLeft">
            <div class="orderMsg">
              <div>
                <span>用户账号:</span>
                <span>{{ dataList.mobile }}</span>
              </div>
              <div>
                <span>用户昵称:</span>
                <span>{{ dataList.name }}</span>
              </div>
              <div>
                <span>用户创建时间:</span>
                <span>{{ dataList.stringCreateTime }}</span>
              </div>
              <div>
                <span>用户注册类型:</span>
                <span v-if="dataList.certificatetype === 1">公司注册</span>
                <span v-if="dataList.certificatetype === 2">个人注册</span>
              </div>
              <div>
                <span>用户证件信息:</span>
                <div class="cardbox" v-if="dataList.certificatetype === 2">
                  <span>身份证正面</span>
                  <img :src="dataList.idcardpositiveimg" alt="" />
                  <span>身份证反面</span>
                  <img :src="dataList.idcardoppositeimg" alt="" />
                </div>
                <div class="cardbox" v-if="dataList.certificatetype === 1">
                  <span>营业执照</span>
                  <img :src="dataList.businessimg" alt="" />
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="24">
            <p style="text-align: center; margin-top: 25px">常用发件地址</p>
            <el-button
              type="danger"
              class="el-icon-delete"
              style="margin-bottom: 20px"
              @click="BatchDelete"
              >批量删除按钮</el-button
            >
            <el-table
              :data="tableData"
              @select="selectCheckbox"
              @select-all="selectCheckbox"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column prop="xh" label="序号"> </el-table-column>
              <el-table-column prop="name" label="姓名">
                <template slot-scope="scope">
                  <el-tooltip
                    effect="dark"
                    :content="scope.row.name"
                    placement="top"
                  >
                    <span>{{ scope.row.name }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="tel" label="联系手机">
                <template slot-scope="scope">
                  <el-tooltip
                    effect="dark"
                    :content="scope.row.tel"
                    placement="top"
                  >
                    <span>{{ scope.row.tel }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="cmpname" label="公司名称">
                <template slot-scope="scope">
                  <el-tooltip
                    effect="dark"
                    :content="scope.row.cmpname"
                    placement="top"
                  >
                    <span>{{ scope.row.cmpname }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="address" label="地址">
                <template slot-scope="scope">
                  <el-tooltip
                    effect="dark"
                    :content="scope.row.address"
                    placement="top"
                  >
                    <span>{{ scope.row.address }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="city" label="城市">
                <template slot-scope="scope">
                  <el-tooltip
                    effect="dark"
                    :content="scope.row.city"
                    placement="top"
                  >
                    <span>{{ scope.row.city }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="postcode" label="邮编">
                <template slot-scope="scope">
                  <el-tooltip
                    effect="dark"
                    :content="scope.row.postcode"
                    placement="top"
                  >
                    <span>{{ scope.row.postcode }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="country" label="国家">
                <template slot-scope="scope">
                  <el-tooltip
                    effect="dark"
                    :content="scope.row.country"
                    placement="top"
                  >
                    <span>{{ scope.row.country }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="emial" label="邮箱">
                <template slot-scope="scope">
                  <el-tooltip
                    effect="dark"
                    :content="scope.row.emial"
                    placement="top"
                  >
                    <span>{{ scope.row.emial }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="operation" label="操作">
                <template slot-scope="scope">
                  <div>
                    <el-dropdown>
                      <span class="el-dropdown-link">
                        更多操作<i
                          class="el-icon-arrow-down el-icon--right"
                        ></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="deladdress(scope.row)">
                          删除
                        </el-dropdown-item>
                        <el-dropdown-item
                          @click.native="alteraddress(scope.row)"
                        >
                          修改
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="24">
            <p style="text-align: center; margin-top: 25px">常用收件地址</p>
            <el-button
              type="danger"
              class="el-icon-delete"
              style="margin-bottom: 20px"
              @click="BatchDelete"
              >批量删除按钮</el-button
            >
            <el-table
              :data="tableDatatow"
              @select="selectCheckbox"
              @select-all="selectCheckbox"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column prop="xh" label="序号"> </el-table-column>
              <el-table-column prop="name" label="姓名">
                <template slot-scope="scope">
                  <el-tooltip
                    effect="dark"
                    :content="scope.row.name"
                    placement="top"
                  >
                    <span>{{ scope.row.name }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="tel" label="联系手机">
                <template slot-scope="scope">
                  <el-tooltip
                    effect="dark"
                    :content="scope.row.tel"
                    placement="top"
                  >
                    <span>{{ scope.row.tel }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="cmpname" label="公司名称">
                <template slot-scope="scope">
                  <el-tooltip
                    effect="dark"
                    :content="scope.row.cmpname"
                    placement="top"
                  >
                    <span>{{ scope.row.cmpname }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="address" label="地址">
                <template slot-scope="scope">
                  <el-tooltip
                    effect="dark"
                    :content="scope.row.address"
                    placement="top"
                  >
                    <span>{{ scope.row.address }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="city" label="城市">
                <template slot-scope="scope">
                  <el-tooltip
                    effect="dark"
                    :content="scope.row.city"
                    placement="top"
                  >
                    <span>{{ scope.row.city }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="postcode" label="邮编">
                <template slot-scope="scope">
                  <el-tooltip
                    effect="dark"
                    :content="scope.row.postcode"
                    placement="top"
                  >
                    <span>{{ scope.row.postcode }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="country" label="国家">
                <template slot-scope="scope">
                  <el-tooltip
                    effect="dark"
                    :content="scope.row.country"
                    placement="top"
                  >
                    <span>{{ scope.row.country }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="taxno" label="收件方税号">
                <template slot-scope="scope">
                  <el-tooltip
                    effect="dark"
                    :content="scope.row.taxno"
                    placement="top"
                  >
                    <span>{{ scope.row.taxno }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="emial" label="邮箱">
                <template slot-scope="scope">
                  <el-tooltip
                    effect="dark"
                    :content="scope.row.emial"
                    placement="top"
                  >
                    <span>{{ scope.row.emial }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="operation" label="操作">
                <template slot-scope="scope">
                  <div>
                    <el-dropdown>
                      <span class="el-dropdown-link">
                        更多操作<i
                          class="el-icon-arrow-down el-icon--right"
                        ></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="deladdress(scope.row)">
                          删除
                        </el-dropdown-item>
                        <el-dropdown-item
                          @click.native="alteraddress(scope.row)"
                        >
                          修改
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <!-- <el-col :span="12" class="centerLeft">
            <div class="orderMsg">
              <img src="../../assets/logo01.png" style="width: 100%" alt="" />
              <div class="borderBottom">
                <h2>From</h2>
                <span>日期</span>
                <span>{{ dataList.appointmentdate }}</span>
              </div>
              <div>
                <span>发件人姓名：</span>
                <span>{{ dataList.sendname }}</span>
              </div>
              <div>
                <span>发件人联系方式：</span>
                <span>{{ dataList.sendtel }}</span>
              </div>
              <div style="width: 100%">
                <span>发件人公司名称：</span>
                <span>{{ dataList.sendcmpname }}</span>
              </div>
              <div>
                <span>发件人国家/城市：</span>
                <span
                  >{{ dataList.sendcountry }} / {{ dataList.sendcity }}</span
                >
              </div>
              <div>
                <span>发件人邮编：</span>
                <span>{{ dataList.sendpostcode }}</span>
              </div>
              <div style="width: 100%; height: auto">
                <span
                  style="
                    display: inline-block;
                    vertical-align: top;
                    width: 120px;
                  "
                  >发件人地址：</span
                >
                <span
                  style="
                    width: 75%;
                    word-break: break-all;
                    display: inline-block;
                  "
                  >{{ dataList.sendaddress }}</span
                >
              </div>
              <div class="borderBottom">
                <h2>To</h2>
              </div>
              <div>
                <span>收件人姓名：</span>
                <span>{{ dataList.receiptname }}</span>
              </div>
              <div>
                <span>收件人联系方式：</span>
                <span>{{ dataList.receipttel }}</span>
              </div>
              <div style="width: 100%">
                <span>收件人公司名称：</span>
                <span>{{ dataList.receiptcmpname }}</span>
              </div>
              <div>
                <span>收件人国家/城市：</span>
                <span
                  >{{ dataList.receiptcountry }} /
                  {{ dataList.receiptcity }}</span
                >
              </div>
              <div>
                <span>收件人邮编：</span>
                <span>{{ dataList.receiptpostcode }}</span>
              </div>
              <div>
                <span>收件方税号：</span>
                <span>{{ dataList.receipttaxno }}</span>
              </div>
              <div style="width: 100%">
                <span
                  style="
                    display: inline-block;
                    vertical-align: top;
                    width: 120px;
                  "
                  >收件人地址：</span
                >
                <span
                  style="
                    width: 75%;
                    word-break: break-all;
                    display: inline-block;
                  "
                  >{{ dataList.receiptaddress }}</span
                >
              </div>
              <div class="borderBottom">
                <span style="width: 155px">海关税务编码TAX ID:</span>
                <span>{{ dataList.receipttaxno }}</span>
              </div>
              <div class="borderBottom">
                <span>网络渠道：</span>
                <span v-if="dataList.channeltype === 1">FedEx</span>
                <span v-if="dataList.channeltype === 2">DHL</span>
                <span v-if="dataList.channeltype === 3">TNT</span>
                <span v-if="dataList.channeltype === 4">UPS</span>
                <span v-if="dataList.channeltype === 5">专线</span>
                <span v-if="dataList.channeltype === 6">授权销售代表选择</span>
              </div>
              <div class="borderBottom">
                <span style="vertical-align: top; margin-top: 8%"
                  >支付方式</span
                >
                <div style="display: inline-block">
                  <div style="width: 100%">
                    <span>付款方：</span>
                    <span v-if="dataList.paytype === 1">寄件人</span>
                    <span v-if="dataList.paytype === 2">收件人</span>
                    <span v-if="dataList.paytype === 3">第三方</span>
                  </div>
                  <div style="width: 100%">
                    <span>付款账号：</span>
                    <span>{{ dataList.payaccount }}</span>
                  </div>
                  <div style="width: 100%">
                    <span>付款账号国家：</span>
                    <span>{{ dataList.paycountry }}</span>
                  </div>
                  <div style="width: 100%">
                    <span>付款账号公司：</span>
                    <span>{{ dataList.paycmpname }}</span>
                  </div>
                </div>
              </div>
              <div class="borderBottom">
                <span style="vertical-align: top; margin-top: 8%"
                  >物品信息</span
                >
                <div style="display: inline-block">
                  <div style="width: 100%">
                    <span>包裹箱数：</span>
                    <span>{{ dataList.packagenum }}</span>
                  </div>
                  <div style="width: 100%">
                    <span>包裹总重量：</span>
                    <span>{{ dataList.packageweight }}</span>
                  </div>
                  <div style="width: 100%">
                    <span>包裹尺寸：</span>
                    <span>{{ dataList.packagesize }}</span>
                  </div>
                  <div style="width: 100%">
                    <span
                      style="
                        display: inline-block;
                        vertical-align: top;
                        width: 120px;
                      ">包裹内物品：</span>
                    <span
                      style="
                        width: 75%;
                        word-break: break-all;
                        display: inline-block;
                      ">{{ dataList.packagegoods }}</span>
                  </div>
                  <div style="width: 100%">
                    <span>重量：</span>
                    <span>{{ dataList.weight }}</span>
                  </div>
                  <div style="width: 100%">
                    <span>体积：</span>
                    <span>{{ dataList.volume }}</span>
                  </div>
                  <div style="width: 100%">
                    <span
                      style="
                        display: inline-block;
                        vertical-align: top;
                        width: 120px;
                      "
                      >其他物品：</span
                    >
                    <span
                      style="
                        width: 75%;
                        word-break: break-all;
                        display: inline-block;
                      "
                      >{{ dataList.othergoods }}</span
                    >
                  </div>
                </div>
              </div>
              <div>
                <span>预约日期：</span>
                <span>{{ dataList.appointmentdate }}</span>
              </div>
              <div>
                <span>预约时间：</span>
                <span>{{ dataList.appointmenttime }}</span>
              </div>
              <div>
                <span>预约其他说明：</span>
                <span>{{ dataList.appointmentremark }}</span>
              </div>
              <div style="width: 100%">
                <span>订单号：</span>
                <span>{{ dataList.orderId }}</span>
              </div>
            </div>

            <div class="bottomDiv">
              <img src="../../assets/barcode.png" alt="" />
              <img src="../../assets/QRcode.jpg" alt="" />
              <img src="../../assets/QRcode01.jpg" alt="" />
              <span
                style="
                  position: absolute;
                  bottom: 0;
                  left: 9%;
                  letter-spacing: 12px;
                "
                >{{ dataList.orderId }}</span
              >
            </div>
          </el-col>
          <el-col class="centerRight">
            <p style="width: 12px; font-size: 12px; margin: 10px">
              请沿此线对折
            </p>
          </el-col> -->
        </el-row>
      </el-row>
    </el-row>

    <el-dialog
      title="地址修改"
      :visible.sync="shows"
      width="400px"
      :close-on-click-modal="false"
    >
      <div>
        <div class="demo-input-suffix">
          姓名:
          <el-input placeholder="请输入内容" v-model="name"> </el-input>
        </div>
        <div class="demo-input-suffix">
          联系手机：
          <el-input placeholder="请输入内容" v-model="tel"> </el-input>
        </div>
        <div class="demo-input-suffix">
          公司名称：
          <el-input placeholder="请输入内容" v-model="cmpname"> </el-input>
        </div>
        <div class="demo-input-suffix">
          地址：
          <el-input placeholder="请输入内容" v-model="address"> </el-input>
        </div>
        <div class="demo-input-suffix">
          城市：
          <el-input placeholder="请输入内容" v-model="city"> </el-input>
        </div>
        <div class="demo-input-suffix">
          邮编：
          <el-input placeholder="请输入内容" v-model="postcode"> </el-input>
        </div>
        <div class="demo-input-suffix">
          国家：
          <el-input placeholder="请输入内容" v-model="country"> </el-input>
        </div>
        <div v-if="addtype === 2" class="demo-input-suffix">
          收件方税号：
          <el-input placeholder="请输入内容" v-model="taxno"> </el-input>
        </div>
        <div class="demo-input-suffix">
          邮箱：
          <el-input placeholder="请输入内容" v-model="emial"> </el-input>
        </div>
        <div class="gogo">
          <el-button class="trueChange" @click="alter" type="primary"
            >确认修改</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      deleteAddress: [], //选中要删除的常用地址的id数组
      shows: false,
      loading: true,
      completionTime: "",
      changerTime: "",
      endorserTime: "",
      fundTime: "",
      holderTime: "",
      sideTime: "",
      systemTime: "",
      tickeTime: "",
      stepActiv: 1,
      PriceChange: false,
      oneSrc: "",
      twoSrc: "",
      dialogOne: false,
      dialogTwo: false,
      Receive: false,
      receiveText: "受让方将在约定时间内完成签收，请耐心等候",
      dataList: {},
      oneModal: false,
      twoModal: false,
      inputVal: "",
      yearRate: "",
      yearPrice: "",
      yzmVal: "",
      disabled: false,
      btntxt: "获取验证码",
      showCk: false,
      testData: [],
      dialogV: false,
      inputVal: "",
      comsVal: "",
      arrlist: [],
      msgid: "",
      custNo: "",
      dialogMesg: false,
      Selvalue: "",
      textVal: "",
      moneytre: "",
      moneytwo: "",
      moneyone: "",
      tableData: [],
      tableDatatow: [],
      options: [
        {
          value: "国股",
          label: "国股"
        },
        {
          value: "大商",
          label: "大商"
        },
        {
          value: "城商",
          label: "城商"
        },
        {
          value: "三农",
          label: "三农"
        },
        {
          value: "村镇",
          label: "村镇"
        },
        {
          value: "外贸",
          label: "外贸"
        },
        {
          value: "财票",
          label: "财票"
        }
      ],
      addtype: null,
      status: "",
      id: "",
      name: "",
      tel: "",
      cmpname: "",
      address: "",
      city: "",
      postcode: "",
      country: "",
      taxno: "",
      emial: ""
    };
  },
  mounted() {
    this.handleAjax();
  },
  methods: {
    handleAjax() {
      console.log(this.$route);
      let bizContent = {};
      bizContent.mobile = this.$route.query.mobile;
      bizContent.uid = this.$route.query.uid;
      this.ajax
        .post(this.versatile.withurl + "/user/queryuser", { bizContent })
        .then(result => {
          console.log(result.data.data);
          this.status = result.data.status;
          if (this.status == "0000") {
            this.stepActiv = result.data.data.statusSell;
            this.dataList = result.data.data;
            console.log(this.dataList);
            if (this.dataList.transferlist == undefined) {
            } else {
              let add = this.dataList.transferlist;
              add.map((it, index) => {
                let arr = [];
                arr.push(it.billFrontUrl);
                arr.push(it.billBackUrl);
                it.imglist = arr;
              });
              this.arrlist = add;
            }

            let arr = result.data.data;
            this.moneyone = arr.sellGuarantee;
            this.moneytwo = arr.buyGuarantee;
            this.moneytre = arr.difference;
            this.Selvalue = arr.accepttype;
            this.textVal = arr.demand;

            if (result.data.data.status == 800) {
              if (result.data.data.orderAgreementList == null) {
                this.ajax
                  // .post("http://192.168.3.113:30000/order/orderList", {
                  .post("http://localhost:30000/order/orderList", {
                    bizContent: { merchantCode: "dianpiaobao" }
                  })
                  .then(result => {
                    if (result.data.status == "0000") {
                      this.oneSrc = result.data.data.agreementExtendOne;
                      // this.dialogOne=true
                    } else {
                      this.$message({
                        type: "warning",
                        duration: 5000,
                        message: result.data.message,
                        center: true,
                        offset: 300
                      });
                    }
                  });
              } else {
                this.oneSrc =
                  "https://img.dianpiaobao.com/" +
                  result.data.data.orderAgreementList[0].agreementUrl;
              }
            }
            // else {
            //   //协议
            //   this.ajax
            //     .post("/merchant/getmerchant", {
            //       bizContent: { merchantCode: "dianpiaobao" },
            //     })
            //     .then((result) => {
            //       if (result.data.status == "0000") {
            //         this.oneSrc = result.data.data.agreementExtendOne;
            //         // this.showCk=true
            //       } else {
            //         this.$message({
            //           type: "warning",
            //           duration: 5000,
            //           message: result.data.message,
            //           center: true,
            //           offset: 300,
            //         });
            //       }
            //     });
            // }

            if (result.data.data.status == 620) {
              this.stepActiv = 5;
            } else if (result.data.data.status == 600) {
              this.stepActiv = 3;
            } else if (
              result.data.data.status == 800 ||
              result.data.data.status == 810
            ) {
              this.stepActiv = 8;
            } else if (result.data.data.status == 102) {
              this.stepActiv = 1;
            } else if (result.data.data.status == 200) {
              this.stepActiv = 2;
            } else if (result.data.data.status == 700) {
              this.stepActiv = 6;
            } else if (result.data.data.status == 610) {
              this.stepActiv = 4;
            } else if (
              result.data.data.status == 100 ||
              result.data.data.status == 101 ||
              result.data.data.status == 102
            ) {
              this.stepActiv = 1;
            }
          } else {
            this.$message({
              type: "warning",
              duration: 5000,
              message: result.data.message,
              center: true,
              offset: 300
            });
          }
        });
      this.ajax
        .post(this.versatile.withurl + "/address/addressList", { bizContent })
        .then(result => {
          // console.log(result.data.data);
          let arr = result.data.data;
          arr.map(item => {
            if (item.uid === parseInt(this.$route.query.uid)) {
              if (item.addtype === 1) {
                this.tableData.push(item);
              } else if (item.addtype === 2) {
                this.tableDatatow.push(item);
              }
              this.loading = false;
            }
          });
          this.tableData.map((it, index) => {
            it.xh = index + 1;
          });
          this.tableDatatow.map((it, index) => {
            it.xh = index + 1;
          });
        });
    },
    deladdress(val) {
      console.log(val);
      let bizContent = {};
      bizContent.id = val.id;
      this.ajax
        .post(this.versatile.withurl + "/address/deleteaddress", { bizContent })
        .then(result => {
          if (result.data.status === "0000") {
            location.reload();
          }
        });
    },
    alteraddress(val) {
      console.log(val);
      this.addtype = val.addtype;
      this.id = val.id;
      this.name = val.name;
      this.tel = val.tel;
      this.cmpname = val.cmpname;
      this.address = val.address;
      this.city = val.city;
      this.postcode = val.postcode;
      this.country = val.country;
      this.taxno = val.taxno;
      this.emial = val.emial;
      this.shows = !this.shows;
    },
    handleMoney() {
      this.$router.push({
        name: "moneyTrue"
      });
    },
    handleCcClick(val) {
      let list = [];
      list.push(val.billFrontUrl);
      list.push(val.billBackUrl);
    },
    handleShowOne(val) {
      this.dialogOne = !this.dialogOne;
    },
    handleShowTwo(val) {
      if (val == "") {
        this.$message("该授权书签约后可查看");
        return false;
      }
      let url = "https://img.borntrust.com/" + val;
      this.twoSrc = url;
      this.dialogTwo = !this.dialogTwo;
    },
    handleCxClick(val) {
      this.$confirm("您确定要撤单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$api
            .post("/jyorder/orderUpOrDown", {
              bizContent: {
                orderId: this.dataList.orderId,
                uid: this.$store.state.userId,
                statusType: "1"
              }
            })
            .then(result => {
              if (result.status == "0000") {
                this.$message("撤单成功！");
                this.$message({
                  type: "success",
                  duration: 5000,
                  message: "撤单成功！",
                  center: true,
                  offset: 300
                });
                this.handleAjax();
              } else {
                this.$message({
                  type: "warning",
                  duration: 5000,
                  message: result.data.message,
                  center: true,
                  offset: 300
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消撤单"
          });
        });
    },
    handleGets() {
      this.dialogV = !this.dialogV;
    },
    handleClick(val) {
      // this.dialogMesg=!this.dialogMesg
      console.log(11);
    },
    handleSearCom() {
      this.ajax
        .post("/jyOder/getcompanybyphone", {
          bizContent: { phone: this.inputVal }
        })
        .then(result => {
          if (result.data.status == "0000") {
            this.comsVal = result.data.data.companyName;
            this.custNo = result.data.data.custNo;
          } else {
          }
        });
    },
    submitForm() {
      this.ajax
        .post("/jyOder/dispatchorder", {
          bizContent: {
            oderId: this.$route.query.oId,
            uid: this.$store.state.userId,
            phone: this.inputVal,
            name: this.comsVal,
            custNo: this.custNo
          }
        })
        .then(result => {
          if (result.data.status == "0000") {
            this.dialogV = false;
            this.handleAjax();
            this.$message({
              type: "success",
              duration: 5000,
              message: "指派成功！",
              center: true,
              offset: 300
            });
          } else {
          }
        });
    },
    alter() {
      let bizContent = {};
      bizContent.id = this.id;
      bizContent.name = this.name;
      bizContent.tel = this.tel;
      bizContent.cmpname = this.cmpname;
      bizContent.address = this.address;
      bizContent.city = this.city;
      bizContent.postcode = this.postcode;
      bizContent.country = this.country;
      bizContent.taxno = this.taxno;
      bizContent.emial = this.emial;
      this.ajax
        .post(this.versatile.withurl + "/address/updateaddress", { bizContent })
        .then(result => {
          if (result.data.status === "0000") {
            location.reload();
          }
        });
    },
    changeClick() {
      let bizContent = {};
      bizContent.orderId = this.$route.query.oId;
      bizContent.sellGuarantee = this.moneyone;
      bizContent.buyGuarantee = this.moneytwo;
      bizContent.difference = this.moneytre;
      bizContent.demand = this.textVal;
      bizContent.accepttype = this.Selvalue;
      this.ajax.post("/jyOder/jyPiaoDetail", { bizContent }).then(result => {
        if (result.data.status == "0000") {
          this.dialogMesg = false;
          this.$message({
            type: "success",
            duration: 5000,
            message: "信息补充成功！",
            center: true,
            offset: 300
          });
        } else {
        }
      });
    },
    handleShowBigOne() {
      this.oneModal = !this.oneModal;
    },
    handleShowBigTwo() {
      this.twoModal = !this.twoModal;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
          this.handleAjax();
        })
        .catch(_ => {});
    },
    handleChangePrice(val) {
      this.PriceChange = true;
    },
    handleInputs() {
      let bizContent = {};
      bizContent.mswkx = this.inputVal;
      bizContent.rate = "";
      bizContent.billAmt = this.dataList.getMony;
      bizContent.endDate = this.dataList.endDate;
      this.ajax.post("/jyorder/getZKLORRATE", { bizContent }).then(result => {
        if (result.data.status == "0000") {
          this.yearRate = result.data.data.rate;
          this.yearPrice = result.data.data.getMony + "元";
        } else {
          // this.$message(result.data.message);
          this.$message({
            type: "warning",
            duration: 5000,
            message: result.data.message,
            center: true,
            offset: 300
          });
        }
      });
    },
    handleGetYZM() {
      let bizContent = {};
      bizContent.mobile = this.$store.state.userInfor;
      bizContent.type = "pricepsd";
      bizContent.mergeKey = "";
      this.ajax
        .post(this.versa.imgUrl + "/sms/sendSms", { bizContent })
        .then(result => {
          if (result.data.status == "0000") {
            this.$message({
              type: "success",
              duration: 5000,
              message: "验证码已发送至您的手机上",
              center: true,
              offset: 300
            });
            this.time = 60;
            this.disabled = true;
            this.timer();
          } else {
            // this.$message(result.data.message);
            this.$message({
              type: "warning",
              duration: 5000,
              message: result.data.message,
              center: true,
              offset: 300
            });
          }
        });
    },
    timer: function() {
      if (this.time > 0) {
        this.time--;
        this.btntxt = this.time + "s后重新获取";
        setTimeout(this.timer, 1000);
        this.disabled = true;
      } else {
        this.time = 0;
        this.btntxt = "获取验证码";
        this.disabled = false;
      }
    },
    handleTruePrice() {
      let bizContent = {};
      bizContent.uid = this.$store.state.userId;
      bizContent.orderId = this.dataList.orderId;
      bizContent.tenThousandDiscount = this.inputVal;
      bizContent.channelYearRate = this.yearRate;
      bizContent.smsCode = this.yzmVal;
      this.ajax
        .post("/jyorder/jyOrderSellChangePrice", { bizContent })
        .then(result => {
          if (result.data.status == "0000") {
            this.$message({
              type: "success",
              duration: 5000,
              message: "改价成功！",
              center: true,
              offset: 300
            });
            this.handleAjax();
          } else {
            // this.$message(result.data.message);
            this.$message({
              type: "warning",
              duration: 5000,
              message: result.data.message,
              center: true,
              offset: 300
            });
          }
        });
    },
    handleSetCard() {
      this.handleAjax();
      this.Receive = false;
    },
    handleGetBook(val) {
      this.Recited = true;
    },
    handleCopy(val) {
      const input = document.createElement("input");
      document.body.appendChild(input);
      input.setAttribute("value", val);
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
      }
      document.body.removeChild(input);
      this.$message("复制成功");
    },
    toBack() {
      this.$router.go(-1);
    },
    toOrder() {
      this.$router.push({
        path: "/bankacceptance/Custom",
        query: {
          payaccount: this.$route.query.mobile
        }
      });
    },
    //checkbox单选触发    //checkbox全选触发

    selectCheckbox(selection, row) {
      console.log(selection);
      var arr = [];
      selection.map(res => {
        arr.push(res.id);
        // this.deleteAddress.push(res.id);
      });
      this.deleteAddress = arr;
    }, //批量删除按钮
    BatchDelete() {
      console.log(this.deleteAddress);
      this.$confirm("此操作将会永久删除该地址, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var ids = this.deleteAddress.join(",");
          console.log(ids);
          this.ajax
            .post(this.versatile.withurl + "/address/batchdeleteaddress", {
              bizContent: { ids: ids }
            })
            .then(res => {
              this.$message.success("删除成功!");
              location.reload();
            });
        })
        .catch(() => {
          this.$message.info("已取消删除!");
          this.deleteAddress = [];
        });
    }
  }
};
</script>

<style scoped>
.bottomDiv {
  width: 100%;
  padding: 0 10%;
  height: 90px;
}
.bottomDiv img {
  height: 65px;
  display: inline-block;
  margin: 0 20px;
}
.borderBottom {
  margin-top: 10px;
  width: 100% !important;
  height: 100% !important;
  border-bottom: 2px solid #333;
}
.borderBottom h2 {
  /* padding-left: 10px; */
  width: 70%;
  display: inline-block;
  font-weight: 600;
  font-size: 18px;
}
.orderBox {
  margin-left: 20px;
  background: rgba(255, 255, 255, 1);
  width: 1300px;
}

.orderCenter {
  margin-top: 0px;
}

.borde {
  height: 60px;
  line-height: 60px;
  /* width: 100%; */
  border: 1px solid rgba(227, 228, 229, 1);
  background: rgba(252, 252, 252, 1);
  margin-bottom: 20px;
  border-radius: 4px 4px 0px 0px;
}

.bordeLeft {
  font-weight: 400;
  padding-left: 20px;
  font-size: 18px;
  color: rgba(51, 51, 51, 1);
  width: 480px;
  height: 25px;
  line-height: 25px;
  font-family: PingFangSC-Regular, PingFang SC;
  margin-top: 14px;
  /* background:rgba(252,252,252,1); */
}

/* .el-col {
    border-radius: 4px;
  } */

.wrapper {
  display: flex;
}
.left {
  width: 220px;
  text-align: left;
  box-shadow: 0 0 black;
}
.right {
  display: flex;
  height: 96px !important;
  margin-left: 10px;
  box-shadow: 0 0 black;
}
.pic1,
.pic2 {
  width: 135px;
  height: 96px !important;
  margin-left: 20px;
  text-align: center;
}
.showbig {
  margin-bottom: 5px;
  margin-top: 10px;
  color: #007aff;
  display: inline-block;
}
.showbig:hover {
  cursor: pointer;
}
.odd {
  color: cornflowerblue;
  text-decoration: underline;
}
.odd:hover {
  cursor: pointer;
  color: black;
}

.button {
  background: #3e5f9cff;
  margin-top: 20px;
}

.step {
  padding-top: 26px;
  background: rgba(255, 255, 255, 1);
  height: 104px;
  margin-bottom: 40px;
}

.statusRow {
  width: 1250px;
  height: 55px;
  margin-left: 20px;
  line-height: 55px;
  background: rgba(252, 252, 252, 1);
  border-radius: 4px 4px 0px 0px;
  border: 1px solid rgba(227, 228, 229, 1);
}

.status {
  height: 55px;
  line-height: 55px;
  padding-left: 18px;
}

.center {
  /* background: cadetblue; */
  width: 1250px;
  margin-left: 20px;
  /* height: 420px; */
  border: 1px solid rgba(239, 239, 239, 1);
}

.centerLeft {
  width: 50%;
  /* height: 420px; */
}
.orderMsg {
  padding-top: 9px;
  padding-left: 17px;
}
.centerRight {
  /* background: rgba(252, 252, 252, 1); */
  width: 408px;
  height: 820px;
  border-left: 1px dashed #333;
}
.dodos {
  width: 1248px;
  height: 320px;
  margin-left: 20px;
  border: 1px solid rgba(239, 239, 239, 1);
}
.dodoLeft {
  width: 840px;
  height: 320px;
}
.dodoRight {
  background: rgba(252, 252, 252, 1);
  width: 408px;
  height: 320px;
  border-left: 1px solid rgba(239, 239, 239, 1);
  border-top: 1px solid rgba(239, 239, 239, 1);
  text-align: center;
}
.changeStatus {
  padding: 20px 30px;
  text-align: center;
}
.pone {
  font-size: 14px;
  color: #333;
  margin-bottom: 20px;
}
.ptwo {
  font-size: 22px;
  color: #198af1;
  margin-bottom: 10px;
}
.ptre {
  font-size: 14px;
  color: #666;
}
.pfiv {
  font-size: 14px;
  color: #198af1;
}
.marss {
  margin-top: 20px;
}
.orderMsg >>> div {
  /* display: inline-block;
  width: 49%;
  height: 20px; */
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(85, 85, 85, 1);
  line-height: 20px;
  margin-bottom: 5px;
}
.orderMsg >>> div span:first-child {
  display: inline-block;
  width: 120px;
  /* color: red; */
}
.line {
  width: 820px;
  height: 2px !important;
  background: #e8e7e7;
  margin-bottom: 16px !important;
}

.changePrice {
  padding-top: 160px;
  text-align: center;
  /* border: none; */
}

.changePrice >>> div {
  margin: 20px 0;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
}

.firstButton {
  border-radius: 4px;
  border: 1px solid rgba(58, 91, 160, 1);
  box-sizing: border-box;
  color: #3e5f9c;
}

.agreement {
  width: 1250px;
  height: auto;
  border: 1px solid rgba(239, 239, 239, 1);
  margin-bottom: 10px;
  margin-left: 19px;
  padding: 24px 0;
  padding-left: 18px;
}
.titTop {
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(85, 85, 85, 1);
  line-height: 17px;
  margin-bottom: 20px;
}

.waiting {
  padding-top: 196px;
  text-align: center;
}

.waitingText {
  margin-bottom: 42px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
}

.waiting >>> .el-button {
  height: 35px;
  background: rgba(62, 95, 156, 1);
  border-radius: 4px;
}

.success {
  padding-top: 144px;
  text-align: center;
}
.iconWrap {
  font-size: 37px;
  color: #3e5f9c;
}

.successText {
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
  margin-top: 33px;
  margin-bottom: 20px;
}

.recite {
  padding-top: 46px;
  text-align: center;
}

.reciteAmount {
  height: 28px;
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 93, 93, 1);
  line-height: 28px;
}

.reciteText {
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
  margin-top: 8px;
  margin-bottom: 4px;
}

.reciteTime {
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 17px;
  margin-bottom: 33px;
}

.resignAccount {
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(85, 85, 85, 1);
  line-height: 22px;
  margin-bottom: 21px;
}

.bankText {
  margin-bottom: 12px;
  text-align: left;
  padding-left: 40px;
}
.first {
  width: 84px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(85, 85, 85, 1);
  line-height: 20px;
}

.second {
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(85, 85, 85, 1);
  line-height: 20px;
}

.third {
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 122, 255, 1);
  line-height: 17px;
}

.notice {
  text-align: center;
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 93, 93, 1);
  line-height: 17px;
  margin-bottom: 20px;
}

.howRecite {
  border: none;
  background: none;
  color: #007aff;
  text-decoration: underline;
}

.changePrice >>> .moreWrap {
  color: #d8d8d8;
  font-size: 30px;
}
.jkl {
  height: 80px;
  width: 100px;
}
.uzi {
  height: 100%;
  width: 100%;
}
.Price {
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  line-height: 30px;
  font-weight: 400;
  margin-bottom: 20px;
  height: 160px;
  text-align: center;
}
.chaprice {
  font-size: 16px;
  margin-bottom: 7px;
  color: #3e5f9cff;
}
.zxcv {
  text-align: right;
  padding-right: 50px;
}
.poiu {
  text-align: left;
}
.poiu >>> .el-input__inner {
  height: 30px;
}
.loPhone {
  /* margin: auto; */
  text-align: left;
  padding-left: 89px;
  height: 60px;
}

.loPhoneText {
  padding-top: 9px;
  width: 70px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(113, 113, 113, 1);
  line-height: 20px;
  margin-right: 12px;
}
.inmnb {
  width: 80px;
}
.loPhoneInput {
  width: 200px;
  height: 34px;
}
.fko {
  text-align: center;
}
.subsd {
  height: 35px;
  width: 106px;
  background: #3e5f9cff;
  color: #fff;
  margin: auto;
}
.buttons {
  border: none;
  background: #fff;
  color: #3e5f9cff;
}
.textWrap {
  text-align: center;
}
.fuzhi {
  color: #007affff;
  margin-left: 3px;
}
.fuzhi:hover {
  cursor: pointer;
}
.step >>> .el-step__title.is-process {
  font-weight: 500 !important;
}
.step >>> .el-step__head.is-process {
  color: #666 !important;
  border-color: #666 !important;
}
.treeCon {
  margin-top: 20px;
  height: 626px;
  width: 880px;
  margin-bottom: 10px;
  /* background: #F4F6F8FF; */
}
.emb {
  height: 100%;
  width: 100%;
  margin: auto;
}
.mrsp {
  font-size: 16px;
  font-weight: 600;
  margin-top: 40px;
}
.mars {
  margin-top: 40px;
}
.dodotop {
  height: 159px;
  width: 100%;
  border-bottom: 1px solid #efefef;
}
.dodobot {
  height: 160px;
  width: 100%;
}
.vsas {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
}
.titbot {
  color: #555;
  font-size: 12px;
}
.tablesbox {
  padding: 0 20px;
}
.tablesbox >>> .cell {
  text-align: center;
}
.mnv {
  overflow: hidden;
  margin-bottom: 20px;
}
.bud {
  text-align: center;
  margin-top: 20px;
}
.butg {
  background: #3e5f9cff;
  color: #fff;
}
.cardbox {
  position: relative;
  width: 50%;
  display: inline-block;
  vertical-align: middle;
}
.cardbox img {
  width: 45%;
  padding-bottom: 25px;
}
.cardbox span {
  position: absolute;
  bottom: 0;
  margin-left: 10%;
}
</style>



// WEBPACK FOOTER //
// src/PAGE/bankAcceptance/controlinfo.vue